import React, { useEffect, useState } from "react";
import { errorNotification } from "../Generic/Notifications";
import { Table, Tbody, Tcol, Thead, Trow } from "../Generic/Table";
import EmptyState from "../Generic/EmptyState";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as TaskActions from "./actions/taskActions";
import TaskService from "./services";
import { TASK_STATUSES } from "./TaskConstants";
import { beautifyKey, debounce } from "../util/util";
import Loader from "../Generic/Loader";
import AddFilters from "../Generic/AddFilters";
import Icons from "../Generic/SvgIcons";
import useQuery from "../util/hooks/useQuery";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 1rem;
`;

const Header = styled.div`
	display: flex;
	font-size: 2rem;
	margin: 1rem 0 0 0.5rem;
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: ${(props) => props.margin};
`;

function dateToString(date) {
	return new Date(date).toLocaleString();
}

const TaskList = (props) => {
	const { machineID, kitchenId } = props;
	const pageQuery = useQuery();

	const [taskList, setTaskList] = useState([]);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(pageQuery.size ? true : false);

	async function getTasksByFilter(filters) {
		if (!filters?.length) {
			setTaskList([]);
			return;
		}
	
		const response = await TaskService.getTasksByFilter(filters);
		const { data, error } = response;
		if (data) {
			setTaskList(data);
		}
		if (error) {
			errorNotification(error);
			console.log(error);
		}
		setLoading(false);
	}

	function navigateToTaskPage(taskId) {
		navigate(`/${machineID}/task/${taskId}`);
	}

	function renderTaskList(tasks, loading) {
		if (tasks.length) {
			let tasksRenderData = tasks.map((task, index, array) => {
				const { _id, taskType, taskGroupId, status, actualEndTime, actualStartTime } = task;
				const endTimeString = actualEndTime ? dateToString(actualEndTime) : "-";
				const startTimeString = actualStartTime ? dateToString(actualStartTime) : "-";
				return (
					<Trow onClick={() => navigateToTaskPage(_id)}>
						<Tcol borderRadius="10px 0 0 10px">{_id}</Tcol>
						<Tcol>{beautifyKey(taskType)}</Tcol>
						<Tcol>{taskGroupId}</Tcol>
						<Tcol>{TASK_STATUSES[status]}</Tcol>
						<Tcol>{startTimeString}</Tcol>
						<Tcol borderRadius="0 10px 10px 0">{endTimeString}</Tcol>
					</Trow>
				);
			});
			return (
				<Table>
					<Trow head>
						<Thead>Task ID</Thead>
						<Thead>Task Type</Thead>
						<Thead>Task Group ID</Thead>
						<Thead>Task Status</Thead>
						<Thead>Start Time</Thead>
						<Thead>End Time</Thead>
					</Trow>
					<Tbody>{tasksRenderData}</Tbody>
				</Table>
			);
		} else if (!loading) {
			return <EmptyState />;
		}
	}

	function handleFiltersUpdate(filters, noDebounce = false) {
		setLoading(true);
		if (noDebounce) {
			getTasksByFilter(filters);
		} else {
			debounce(() => {
				getTasksByFilter(filters);
			}, 500);
		}
	}

	useEffect(() => {
		const taskGroupId = pageQuery.get("taskGroupId");
		if (taskGroupId) {
			handleFiltersUpdate([{ type: "taskGroupId",  value: taskGroupId  }], true);
		}
	}, [pageQuery]);

	return (
		<Page>
			<Header>Search Tasks</Header>
			<AddFilters
				onUpdate={handleFiltersUpdate}
				filterTypes={[{ key: "taskGroupId", label: "Task Group ID", type: "text", icon: Icons.hash }]}
			/>

			{renderTaskList(taskList, loading)}
			{loading ? (
				<CenteredContainer>
					<Loader />
				</CenteredContainer>
			) : (
				""
			)}
		</Page>
	);
};

const mapStateToProps = (state) => {
	const { task, landing } = state;
	return { ...task, ...landing };
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators(
		{
			...TaskActions,
		},
		dispatch
	),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskList);
